import { ReactNode } from 'react'
import { usePermission } from '../hooks/usePermission'
import { PermissionModule, PermissionAction } from '../core/stores/permissionStore'

interface PermissionGateProps {
  module: PermissionModule
  action: PermissionAction
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Nasconde i children se l'utente non ha il permesso richiesto.
 * Uso: <PermissionGate module="offerte" action="create"><Button>Nuova</Button></PermissionGate>
 */
export function PermissionGate({ module, action, children, fallback = null }: PermissionGateProps) {
  const allowed = usePermission(module, action)
  return allowed ? <>{children}</> : <>{fallback}</>
}
